import React, { useState } from 'react';
import { Container, Input, Label, Result, Text } from '../../styles';
import Base from '../Base';


function Ranking() {


  // 変更する
  // ---------------------------------------------
  // 2022.4.28
  // 921,4605(sum,cost)

  const roundPointInit = 10000; // 1試合獲得pt(ボーナス前)

  const [bonus, setBonus] = useState(500);
  const [round, setRound] = useState(roundPointInit);

  const roundPointBonus = round * (1 + bonus / 100); // 1周獲得pt(ボーナス後)


  // 表示設定
  // ---------------------------------------------
  // const [digits, setDigits] = useState(0);
  const digits = 0;
  const [object, setObject] = useState(30000000);
  // ---------------------------------------------

  // 確認する
  // 初期設定
  // ---------------------------------------------


  // ---------------------------------------------

  const energy = object / roundPointBonus

  //   消費エナジー変更
  const handleObjectChange = (event) => {
    setObject(event.target.value);
  };

  const handleBonusChange = (event) => {
    setBonus(event.target.value);
  };

  const handleRoundChange = (event) => {
    setRound(event.target.value);
  };

  return (
    <>
      <Base body={
        <Container>
          <Label>
            <Text>目標Pt：</Text>
            <Input type="number" value={object} onChange={handleObjectChange} />
          </Label>
          <Label>
            <Text>ボーナス(％)：</Text>
            <Input type="number" value={bonus} onChange={handleBonusChange} />
          </Label>
          <Label>
            <Text>1試合獲得Pt：</Text>
            <Input type="number" value={Math.ceil(round)} onChange={handleRoundChange} />
          </Label>
          <div>
            <p>1試合獲得Ptにはボーナス適用前の値を入力してください</p>
          </div>
          <Result>
            <p>{Math.ceil(energy)}エナジー必要です。</p>
          </Result>
        </Container>
      } title="ランキングイベント汎用" />
    </>
  );
}

export default Ranking;
